import { BadgeVariant } from '@tallo/design-system';

/** A seat's role in its company. */
export enum CompanyRole {
  ADMIN = 'admin',
  MEMBER = 'member',
}

export const companyRoleLabels: Record<CompanyRole, string> = {
  [CompanyRole.ADMIN]: 'Admin',
  [CompanyRole.MEMBER]: 'Member',
};

/** Violet, so an admin never reads as a unit's manager (orange on the property Team tab) */
export const companyRoleBadgeVariants: Record<CompanyRole, BadgeVariant> = {
  [CompanyRole.ADMIN]: 'violet',
  [CompanyRole.MEMBER]: 'grey',
};

/** What each role may do, as the invite and the role change explain it */
export const companyRoleDescriptions: Record<CompanyRole, string> = {
  [CompanyRole.ADMIN]: 'Changes any property, runs every portfolio and manages the team.',
  [CompanyRole.MEMBER]:
    'Sees every property. Changes the ones they manage or collaborate on, and every property in a portfolio they own.',
};
